import { TabPageDefinition } from '@/components/tab-pages';

export const schoolTabs = (selectedTab?: string): TabPageDefinition[] => {
  return [
    {
      label: 'Schools',
      linkProps: { to: '/orgs/schools' },
      isSelectedTab: selectedTab === 'schools',
    },
    {
      label: 'Weekly report',
      linkProps: { to: '/orgs/schools/reports' },
      isSelectedTab: selectedTab === 'reports',
    },
    {
      label: 'Districts',
      linkProps: { to: '/orgs' },
      isSelectedTab: selectedTab === 'districts',
    },
  ];
};

export const schoolDetailsTabs = (params: Record<string, string>, selectedTab?: string): TabPageDefinition[] => {
  return [
    {
      label: 'Schedules',
      linkProps: {
        to: '/orgs/schools/$schoolId/schedules',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'schedules',
    },
    {
      label: 'Students',
      linkProps: {
        to: '/orgs/schools/$schoolId/students',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'students',
    },
    {
      label: 'Classes',
      linkProps: {
        to: '/orgs/schools/$schoolId/classes',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'classes',
    },
    {
      label: 'One-time Classes',
      linkProps: {
        to: '/orgs/schools/$schoolId/one-time-classes',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'one-time-classes',
    },
    {
      label: 'Sessions',
      linkProps: {
        to: '/orgs/schools/$schoolId/sessions',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'sessions',
    },
    {
      label: 'Session attendance',
      linkProps: {
        to: '/orgs/schools/$schoolId/session-attendance',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'session-attendance',
    },
    {
      label: 'General',
      linkProps: {
        to: '/orgs/schools/$schoolId',
        params: { schoolId: params.schoolId },
      },
      isSelectedTab: selectedTab === 'general',
    },
  ];
};
